<template>
  <el-table :data="tableData" stripe style="width: 100%" ref="typeTable" border v-loading="typesLoading">
    <af-table-column prop="typeName" label="型号名称"></af-table-column>
    <af-table-column prop="typeModel" label="型号代码"></af-table-column>
    <af-table-column prop="gunCount" label="充电枪数量"></af-table-column>
    <af-table-column prop="ratedPower" label="额定功率"></af-table-column>
    <af-table-column prop="outputVoltageRange" label="输出电压范围(VDC)"></af-table-column>
    <af-table-column prop="outputCurrentRange" label="输出电流范围(A)"></af-table-column>
    <!--                <af-table-column prop="chargingCurrentRangePerGun" label="每把枪均充电流范围（A）"></af-table-column>-->
    <af-table-column label="操作" width="240px">
      <template slot-scope="scope">
        <el-button size="mini" plain @click="showViewVisible(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:pileType:saveOrUpdatePileType'])">详情
        </el-button>
        <el-button size="mini" plain @click="typeEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:pileType:updatePileType'])">编辑
        </el-button>
        <el-button size="mini" plain type="danger" @click="typeDelete(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:pileType:deletePileType'])">删除
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "list",
    data(){
      return{

      }
    },
    props:{
      tableData:{},
      typesLoading:false,
    },
    methods:{
      showViewVisible(index,row){
        this.$emit("showViewVisible",index,row)
      },
      typeEdit(index,row){
        this.$emit("typeEdit",index,row)
      },
      typeDelete(index,row){
        this.$emit("typeDelete",index,row)
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/typeManager/list.vue